module.exports = __webpack_public_path__ + "img/pabank.371329b0.png";